export default __webpack_public_path__ + "static/media/12.0fb92e8d.png";